import { Card, Divider, Flex, Tooltip, Typography } from "antd";
import { Button, Col, DatePicker, Form, Input, Modal, Row } from "antd";
import React, { FC, useEffect, useState } from "react";
import { IFetchAllDetails, IPatient } from "../../../interfaces/IPatient";
import { ICreditNote, ICreditNoteData } from "../../../interfaces/IPreAuth";
import dayjs from "dayjs";
import {
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  PrinterFilled,
  PrinterOutlined,
} from "@ant-design/icons";
import CghsDetail from "./Forum/CghsDetail";
import EchsDetail from "./Forum/EchsDetail";
import UpdateAllDetails from "./UpdateAllDetails";
import { IDoctorsState } from "../../../interfaces/IDoctor";
import "./CreditNoteModal.css";
import EchsDetailCNM from "./Forum/EchsDetailCNM";
import CghsDetailCNM from "./Forum/CghsDetailCNM";

type FieldType = {
  items: Array<{
    serviceName: string;
    serviceDate: string;
    serviceQty: string;
  }>;
};

type CreditNoteModalProps = {
  fetchPatientDetail: IPatient | null;
  creditNoteModal: boolean;
  handleCancel: any;
  creditNoteData: ICreditNote | null;
  handleSubmitCreditNote: CallableFunction;
  isLoading: boolean;
  handleDownloadDocument: CallableFunction;
  fetchAllPatientDetails: IFetchAllDetails | null;
  handleOpen?: any;
  calculateAge?: CallableFunction;
  handleDoctorSearch?: CallableFunction;
  availableDoctor?: Array<IDoctorsState>;
  searchLoading?: boolean;
};

const CreditNoteModal: FC<CreditNoteModalProps> = (props) => {
  const [form] = Form.useForm();
  const dateFormat = "DD-MM-YYYY";
  const { Text } = Typography;
  const [isEdit, setIsEdit] = useState(false);
  const [value, setValue] = useState(
    `Thank You for opting for the Healthcare services at our hospital and we assure you our best.
Based on the information provided we are pleased to provide you with the Credit facility for your treatment temporarily for a period of 24 hours from now.
We shall collect further details and submit such information to the THIRD-PARTY ADMINISTRATOR/PAYER as soon as possible.
Kindly be informed that third-party payer is the sole Authority to sanction the credit facility in the unfortunate event of their refusing the cashless facility you must pay the due amount or adjust from the advance amount already paid.
In case you need further details please contact our insurance desk.
Copy to- 1.) Finance  
               2.) Billing    
From: Insurance Desk`
  );

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (props.creditNoteData?.creditNoteItems) {
      const initialValues = {
        items: props.creditNoteData?.creditNoteItems?.map((item) => ({
          id: item?.id,
          serviceName: item?.serviceName,
          serviceDate: item?.serviceDate
            ? dayjs(item?.serviceDate, dateFormat)
            : null,
          serviceQty: item?.serviceQty,
        })),
      };
      form.setFieldsValue(initialValues);
    }
  }, [props.creditNoteData, form]);

  const onFinish = (values: FieldType) => {
    const creditItems = values?.items?.map((item) => {
      return {
        ...item,
        serviceDate: item?.serviceDate
          ? dayjs(item?.serviceDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
      };
    });
    // if (
    //   props?.fetchAllPatientDetails?.casesResponse?.schemeMetaDataName ===
    //     "MEDI ASSIST" ||
    //   props?.fetchAllPatientDetails?.casesResponse?.schemeMetaDataName ===
    //     "STAR HEALTH"
    // )

    if (
      props?.fetchAllPatientDetails?.casesResponse?.schemeType?.toUpperCase() ===
      "TPA"
    ) {
      const updateValues = {
        creditNoteHeader: props?.creditNoteData?.creditNoteHeader,
        note: value,
      };

      props?.handleSubmitCreditNote(updateValues);
      setIsEditing(false);
    } else {
      const updateValues = {
        creditNoteHeader: props?.creditNoteData?.creditNoteHeader,
        creditNoteItems: creditItems,
      };

      props?.handleSubmitCreditNote(updateValues);
    }
  };

  const isFieldDisabled = (fieldId?: string | number) => {
    return !!fieldId;
  };

  const { TextArea } = Input;

  const handleEdit = () => {
    setIsEdit(!isEdit);
  };

  return (
    <Modal
      title={
        <div>
          <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
            CREDIT NOTE
          </span>
        </div>
      }
      centered
      open={props?.creditNoteModal}
      onCancel={props?.handleCancel}
      width={1300}
      style={{ boxShadow: "0px 4px 20px 0px #00000040" }}
      className="credit-note-modal"
      footer={[
        <Button
          key="update"
          loading={props?.isLoading}
          className="update-btn"
          htmlType="submit"
          form="credit-details-form"
        >
          UPDATE CREDIT NOTE
        </Button>,
        <Button
          key="print"
          className="print-btn"
          onClick={() =>
            props?.handleDownloadDocument(
              props?.creditNoteData?.creditNoteHeader?.creditNoteDocumentPath
                ?.split("/")
                ?.pop(),
              props?.creditNoteData?.creditNoteHeader?.creditNoteDocumentPath
            )
          }
        >
          <PrinterFilled /> PRINT CREDIT NOTE
        </Button>,
      ]}
    >
      {!isEdit ? (
        <Form
          form={form}
          id="credit-details-form"
          name="credit-details-form"
          autoComplete="off"
          onFinish={onFinish}
          layout="vertical"
        >
          <Card className="patient-info-card">
            <Row gutter={[16, 16]} className="first-row-noteModal">
              <Col span={4}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderTopLeftRadius: "10px",
                  }}
                  className="patient-card-item"
                >
                  <Text
                    className=""
                    style={{ fontSize: "1rem", fontWeight: "600" }}
                  >
                    {props?.fetchAllPatientDetails?.patientResponse?.fullName}
                  </Text>
                  <Text className="text-weight-cnm">
                    #{props?.fetchAllPatientDetails?.patientResponse?.uhidNo}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Age</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.patientResponse?.age} YEARS
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Gender</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.patientResponse?.sex || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Mobile</Text>
                  <Text className="text-weight-cnm">
                    +91-
                    {props?.fetchAllPatientDetails?.patientResponse
                      ?.primaryMobile || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Case Type</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.casesResponse
                      ?.caseTypeMetaDataName || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderTopRightRadius: "10px",
                  }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Departments</Text>
                  <Text className="text-weight-cnm">
                    {Array.isArray(
                      props?.fetchAllPatientDetails?.visitInfoResponse
                        ?.department
                    )
                      ? props?.fetchAllPatientDetails?.visitInfoResponse?.department?.join(
                          ", "
                        )
                      : "-"}
                  </Text>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="second-row-noteModal">
              <Col span={4}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderBottomLeftRadius: "10px",
                  }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Credit Note No.</Text>
                  <Text strong className="text-weight-cnm">
                    {props?.creditNoteData?.creditNoteHeader?.id || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">IP/OP No.</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.visitInfoResponse
                      ?.opNumber || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Scheme Name</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.casesResponse
                      ?.schemeMetaDataName || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">Card Category</Text>
                  <Text className="text-weight-cnm">
                    {props?.fetchAllPatientDetails?.patientResponse
                      ?.cardCategory || "-"}
                  </Text>
                </div>
              </Col>
              <Col span={4}>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">DOA</Text>
                  <Text className="text-weight-cnm">
                    {dayjs(
                      props?.fetchAllPatientDetails?.visitInfoResponse?.doa,
                      "DD-MM-YYYY HH:mm:ss"
                    ).format("DD-MMM-YYYY hh:mm A")}
                  </Text>
                </div>
              </Col>
              {/* <Col span={4}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    borderBottomRightRadius: "10px",
                  }}
                  className="patient-card-item"
                >
                  <Text className="grey-custom-cnm">DOD</Text>
                  <Text className="text-weight-cnm">
                    {dayjs(
                      props?.fetchAllPatientDetails?.visitInfoResponse?.dod,
                      "DD-MM-YYYY HH:mm:ss"
                    ).format("DD-MMM-YYYY hh:mm A")}
                  </Text>
                </div>
              </Col> */}
            </Row>
          </Card>
          {((props?.fetchAllPatientDetails?.referralInfoResponse
            ?.cghsReferralResponse &&
            props?.fetchAllPatientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() !==
              "CAPF") ||
            props?.fetchAllPatientDetails?.referralInfoResponse
              ?.echsReferralResponse) && (
            <div style={{ marginTop: "2rem" }}>
              <Text
                style={{
                  fontSize: "1rem",
                  color: "#008B8B",
                  fontWeight: "600",
                }}
              >
                REFERRAL INFO:
              </Text>

              {/* <Row gutter={[16, 16]}>
              {props?.fetchAllPatientDetails?.referralInfoResponse
                ?.cghsReferralResponse ||
              props?.fetchAllPatientDetails?.referralInfoResponse
                ?.echsReferralResponse ? (
                <h5
                  className="schemes-heading"
                  style={{
                    fontSize: "14px",
                    // margin: 0,
                    margin: "0.8rem 0",
                    color: "#1677ff",
                  }}
                >
                  {"REFERRAL DETAILS"}
                </h5>
              ) : (
                <></>
              )}
              {props?.fetchAllPatientDetails?.referralInfoResponse
                ?.cghsReferralResponse ? (
                props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.cghsReferralResponse?.documentType && (
                  <div className="file-container" style={{ width: "100%" }}>
                    <h6
                      className=" "
                      style={{
                        fontSize: "12px",
                        // margin: 0,
                        margin: "0.6rem 0",
                      }}
                    >
                      SAVED FILES:
                    </h6>
                    <ul className="list-unstyled">
                      <li
                        className="file-item "
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span className="file-name" style={{ width: "50%" }}>
                          {props?.fetchAllPatientDetails?.referralInfoResponse
                            ?.cghsReferralResponse?.documentName
                            ? props?.fetchAllPatientDetails
                                ?.referralInfoResponse?.cghsReferralResponse
                                ?.documentName.length > 20
                              ? props?.fetchAllPatientDetails?.referralInfoResponse?.cghsReferralResponse?.documentName.substring(
                                  0,
                                  20
                                ) + "..."
                              : props?.fetchAllPatientDetails
                                  ?.referralInfoResponse?.cghsReferralResponse
                                  ?.documentName
                            : ""}
                        </span>
                        <span className="file-name" style={{ width: "25%" }}>
                          {
                            props?.fetchAllPatientDetails?.referralInfoResponse
                              ?.cghsReferralResponse?.documentLabelType
                          }
                        </span>
                        <Flex
                          justify="flex-end"
                          align="center"
                          gap="small"
                          className=" fa-icons"
                          style={{ width: "25%" }}
                        >
                          <>
                            <Tooltip title={"PREVIEW"} color={"blue"}>
                              <EyeOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                  marginRight: "4px",
                                }}
                                onClick={() => {
                                  props?.handleOpen(
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.cghsReferralResponse?.documentUrl
                                  );
                                }}
                              />
                            </Tooltip>
                          </>
                          <Tooltip title="DOWNLOAD" color="blue">
                            <DownloadOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                props?.handleDownloadDocument &&
                                  props?.handleDownloadDocument(
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.cghsReferralResponse?.documentName,
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.cghsReferralResponse?.documentUrl
                                  );
                              }}
                            />
                          </Tooltip>
                        </Flex>
                      </li>
                    </ul>
                  </div>
                )
              ) : props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.echsReferralResponse ? (
                props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.echsReferralResponse?.documentType && (
                  <div className="file-container" style={{ width: "100%" }}>
                    <h6
                      className=" "
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        marginBottom: "0.8rem",
                      }}
                    >
                      SAVED FILES:
                    </h6>
                    <ul className="list-unstyled">
                      <li
                        className="file-item "
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span className="file-name" style={{ width: "50%" }}>
                          {props?.fetchAllPatientDetails?.referralInfoResponse
                            ?.echsReferralResponse?.documentName
                            ? props?.fetchAllPatientDetails
                                ?.referralInfoResponse?.echsReferralResponse
                                ?.documentName.length > 20
                              ? props?.fetchAllPatientDetails?.referralInfoResponse?.echsReferralResponse?.documentName.substring(
                                  0,
                                  20
                                ) + "..."
                              : props?.fetchAllPatientDetails
                                  ?.referralInfoResponse?.echsReferralResponse
                                  ?.documentName
                            : ""}
                        </span>
                        <span className="file-name" style={{ width: "25%" }}>
                          {
                            props?.fetchAllPatientDetails?.referralInfoResponse
                              ?.echsReferralResponse?.documentLabelType
                          }
                        </span>
                        <Flex
                          justify="flex-end"
                          align="center"
                          gap="small"
                          className=" fa-icons"
                          style={{ width: "25%" }}
                        >
                          <>
                            <Tooltip title={"PREVIEW"} color={"blue"}>
                              <EyeOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                  marginRight: "4px",
                                }}
                                onClick={() => {
                                  props?.handleOpen(
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.echsReferralResponse?.documentUrl
                                  );
                                }}
                              />
                            </Tooltip>
                          </>
                          <Tooltip title="DOWNLOAD" color="blue">
                            <DownloadOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                props?.handleDownloadDocument &&
                                  props?.handleDownloadDocument(
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.echsReferralResponse?.documentName,
                                    props?.fetchAllPatientDetails
                                      ?.referralInfoResponse
                                      ?.echsReferralResponse?.documentUrl
                                  );
                              }}
                            />
                          </Tooltip>
                        </Flex>
                      </li>
                    </ul>
                  </div>
                )
              ) : (
                <></>
              )}
            </Row> */}
              <Row style={{ marginTop: "0.4rem", height: "24vh", overflow: "auto" }}>
                {props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.cghsReferralResponse ? (
                  <CghsDetailCNM
                    data={
                      props?.fetchAllPatientDetails?.referralInfoResponse
                        ?.cghsReferralResponse
                    }
                    type="credit-modal"
                  />
                ) : props?.fetchAllPatientDetails?.referralInfoResponse
                    ?.echsReferralResponse ? (
                  <EchsDetailCNM
                    data={
                      props?.fetchAllPatientDetails?.referralInfoResponse
                        ?.echsReferralResponse
                    }
                    type="credit-modal"
                  />
                ) : (
                  <></>
                )}
              </Row>
            </div>
          )}
          {
            /* !(
            props?.fetchAllPatientDetails?.casesResponse?.schemeMetaDataName ===
              "MEDI ASSIST" ||
            props?.fetchAllPatientDetails?.casesResponse?.schemeMetaDataName ===
              "STAR HEALTH"
          ) */
            props?.fetchAllPatientDetails?.casesResponse?.schemeType ===
            "GOVT" ? (
              <div style={{ marginTop: "2rem", overflow: "auto", height: props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.cghsReferralResponse || props?.fetchAllPatientDetails?.referralInfoResponse
                  ?.echsReferralResponse ? "40vh" : "76vh" }}>
                <Text
                  style={{
                    fontSize: "1rem",
                    color: "#008B8B",
                    fontWeight: "600",
                    padding: "10px 0px",
                  }}
                >
                  ADD SERVICE:
                </Text>
                <Card
                  className="add-service-card"
                  style={{ marginTop: "1rem" }}
                >
                  <Form.List name="items">
                    {(fields, { add, remove }) => (
                      <>
                        {fields?.map((field, index) => (
                          <Row key={field.key} gutter={[16, 16]} align="middle">
                            <Col span={13}>
                              <Form.Item
                                {...field}
                                label="Service Name"
                                name={[field.name, "serviceName"]}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                              >
                                <Input
                                  style={{ borderRadius: "5px" }}
                                  placeholder="Enter service name"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                {...field}
                                label="Service Date"
                                name={[field.name, "serviceDate"]}
                              >
                                <DatePicker
                                  style={{ width: "100%", borderRadius: "5px" }}
                                  format={dateFormat}
                                  disabledDate={(current) =>
                                    current
                                      ? current.isBefore(
                                          dayjs().subtract(5, "year")
                                        )
                                      : false
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Form.Item
                                {...field}
                                label="Quantity"
                                name={[field.name, "serviceQty"]}
                                rules={[
                                  { required: true, message: "Required" },
                                  {
                                    pattern: /^\d+$/,
                                    message: "Only Numeric values are allowed!",
                                  },
                                ]}
                              >
                                <Input
                                  style={{ borderRadius: "5px" }}
                                  placeholder="Enter quantity"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={1}>
                              {fields.length > 1 && (
                                <Button
                                  type="text"
                                  style={{ color: "red", padding: "0" }}
                                  icon={<MinusCircleOutlined />}
                                  onClick={() => remove(field.name)}
                                />
                              )}
                            </Col>
                          </Row>
                        ))}
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          style={{
                            color: "white",
                            background: "#008B8B",
                            border: "1px solid #C4C4C4",
                            boxShadow: "0px 2px 8px 0px #00000040",
                          }}
                          // icon={<PlusOutlined />}
                        >
                          Add Row
                        </Button>
                      </>
                    )}
                  </Form.List>
                </Card>
              </div>
            ) : (
              <div style={{ marginTop: "2rem" }}>
                {" "}
                <Text
                  style={{
                    fontSize: "1rem",
                    color: "#008B8B",
                    fontWeight: "600",
                    padding: "10px 0px",
                  }}
                >
                  NOTE:
                </Text>
                <div
                  style={{
                    position: "relative",
                    backgroundColor: "#F7FBFB",
                    border: "0.2px solid #575757",
                    borderRadius: "8px",
                    padding: "17px 30px",
                    marginTop: "0.5rem",
                    fontFamily: "Arial, sans-serif",
                  }}
                >
                  {/* TextArea */}
                  {isEditing ? (
                    <textarea
                      value={value}
                      rows={8}
                      onChange={(e) => setValue(e.target.value)}
                      style={{
                        width: "100%",
                        minHeight: "120px",
                        border: "none",
                        backgroundColor: "transparent",
                        fontSize: "15px",
                        lineHeight: "1.6",
                        textTransform: "initial",
                        color: "#000",
                        resize: "both", // Enable resizing handle
                        overflow: "hidden", // Prevent scrollbars
                        outline: "none", // Remove focus border
                      }}
                    />
                  ) : (
                    <p
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#000",
                        fontWeight: "500",
                        whiteSpace: "pre-wrap",
                        marginBottom: "0px",
                        textTransform: "initial",
                      }}
                    >
                      {value
                        .split(" ")
                        ?.map((word, index) =>
                          word === word.toUpperCase() && /[A-Z]/.test(word) ? (
                            <strong key={index}>{word} </strong>
                          ) : (
                            `${word}${" "}`
                          )
                        )}
                    </p>
                  )}

                  {/* Edit Button */}
                  {!isEditing && (
                    <Button
                      type="text"
                      onClick={() => setIsEditing(!isEditing)}
                      style={{
                        position: "absolute",
                        top: "-15px",
                        right: "20px",
                        // color: "#1890ff",
                        height: "27px",
                        fontSize: "13px",
                        backgroundColor: "#00549E",
                        color: "white",
                        borderRadius: "15px",
                        padding: "0px 20px",
                      }}
                    >
                      Edit
                    </Button>
                  )}
                </div>
              </div>
            )
          }
        </Form>
      ) : (
        // <UpdateAllDetails
        //   searchLoading={props?.searchLoading}
        //   availableDoctor={props?.availableDoctor}
        //   fetchAllPatientDetails?.patientResponse={props?.fetchAllPatientDetails}

        //   handleDoctorSearch={props?.handleDoctorSearch}
        //   isPatientLoading={false}
        //   calculateAge={props?.calculateAge}
        // />
        <></>
      )}
    </Modal>
  );
};

export default CreditNoteModal;
